import { parseAssetCode } from './asset-code.js';
import type { AssetCode } from './asset-code.js';
import type { CurrencyDefinition } from './asset-definition.js';

const eur: CurrencyDefinition = Object.freeze({
  code: parseAssetCode('EUR'),
  scale: 2,
  kind: 'CURRENCY',
});
const usd: CurrencyDefinition = Object.freeze({
  code: parseAssetCode('USD'),
  scale: 2,
  kind: 'CURRENCY',
});

/** Resolves a supported currency from the trusted, fixed catalog. */
export function getCurrencyDefinition(code: AssetCode): CurrencyDefinition {
  switch (code) {
    case 'EUR':
      return eur;
    case 'USD':
      return usd;
    default:
      throw new Error(`Unsupported currency: ${String(code)}`);
  }
}
